import { Close } from "@mui/icons-material"
import { Button } from "@mui/material"

export const MyCloseBtn = ({ handleClose }) => {
    return (
        <Button variant='outlined' startIcon={<Close />} onClick={handleClose}>chiudi</Button>
    )
}